import { toast } from 'react-toastify';

const swalConfig = {
  delete: {
    title: '¿Estás seguro?',
    text: 'No podrás revertir esta acción',
    icon: 'warning',
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: 'Eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
  },
  confirm: {
    title: '¿Estás seguro?',
    // text: 'No podrás revertir esta acción',
    icon: 'question',
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
  },
  imageUpload: {
    title: 'Elige una imagen',
    text: 'Poster 400x600 y Backdrop 1280x720',
    input: 'file',
    inputAttributes: {
      accept: 'image/*',
      'aria-label': 'Imagen',
    },
  },
  confirmImageUpload: {
    title: '¿Estás seguro?',
    text: 'Si existe una imagen anterior esta será reemplazada',
    icon: 'question',
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
  },
  input: {
    title: 'Ingresa un valor',
    input: 'text',
    inputAttributes: {
      autocapitalize: 'off',
    },
    showCancelButton: true,
    confirmButtonText: 'Crear',
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
  },
};

const toastConfig = {
  position: toast.POSITION.TOP_RIGHT,
  className: 'md:w-auto max-w-full mx-3 my-3 md:mx-1',
  delay: 0,
  autoClose: 1000,
  style: {
    position: 'relative',
    zIndex: 9999,
  },
};

export { swalConfig, toastConfig };
